import { OrderType } from '../../types/order.type';

export class FetchAuditData {
    static readonly type = '[Audit] Fetch audit data';
}

export class FetchSectionsWithActions {
    static readonly type = '[Audit] Fetch sections with actions';
}

export class SetSelectedSection {
    static readonly type = '[Audit] Set selected section';
    constructor(public section: string) {
    }
}

export class FetchUsersAudit {
    static readonly type = '[Audit] Fetch users for audit';
}

export class SetAuditDates {
    static readonly type = '[Audit] Set dates';

    constructor(public payload: { range: any; start: string, end: string }) {
    }
}

export class SetSelectedActivity {
    static readonly type = '[Audit] Set activity';

    constructor(public activity: string) {
    }
}

export class SetSelectsUserIds {
    static readonly type = '[Audit] Set user ids';

    constructor(public userIds: number[]) {
    }
}

export class EmitFilterEvent {
    static readonly type = '[Audit] Emit filter event';

    constructor(public submitted: boolean) {
    }
}

export class SortAuditLogs {
    static readonly type = '[Audit] Sort Audit logs';

    constructor(public param: string, public order: OrderType) {
    }
}

export class SearchAuditLogs {
    static readonly type = '[Audit] Search Audit logs';

    constructor(public search: string) {
    }
}

export class SetAuditPage {
    static readonly type = '[Audit] Set audit page';

    constructor(public page: number) {
    }
}
